
// Let child class inherit from parent class
var inherit = function(child, parent) {
    child.prototype = Object.create(parent.prototype);
    child.prototype.constructor = child;
};
module.exports.inherit = inherit;

// Extend given object with all own properties from source
var extend = function(obj, source, allProperties){
    if (obj == undefined) return;
    console.assert(source != undefined, "source of extend is undefined");
    for (var prop in source) {
        if (allProperties || source.hasOwnProperty(prop)) {
            obj[prop] = source[prop];
        }
    }
    return obj;
};
module.exports.extend = extend;

// Mix all own properties from source into prototype of child class
var mixin = function(child, source) {   // excepts 1 or more source objects to mixin
    if (!(child && child.prototype)) return;
    for (var i = 1, length = arguments.length; i < length; i++) {
        extend(child.prototype, arguments[i]);
    }
    return child.prototype;
};
module.exports.mixin = mixin;

// Creates a new instance of Constructor with arguments array
var create = function(Constructor, args) {
    var inst = Object.create(Constructor.prototype);
    Constructor.apply(inst, args);
    return inst;
};
module.exports.create = create;

// Creates a shallow copy of object, unless object has it's own clone function.
var clone = function(obj) {
    if (obj == undefined) return obj;
    // else if (obj.copy) return obj.copy();
    else if (obj.clone) return obj.clone();
    else if (typeof obj == "object") {
        var copy = new obj.constructor();
        return extend(copy, obj);
    } else return obj;
};
module.exports.clone = clone;